import { WidgetTypeFieldGroupItem } from 'adapter/in/common/widget/WidgetTypePreset/useWidgetTypePresetContainer';
import i18n from 'asset/translation';
import { WidgetType } from 'domain/entity/widget';

export const getWidgetTypeFieldGroupItem = (
    widgetType: WidgetType,
    enabledWidgets?: string[],
    isFeaturePresetSelected?: boolean
): WidgetTypeFieldGroupItem => {
    const isDisabled = checkIfDisabledApplies(widgetType, enabledWidgets);
    switch (widgetType) {
        case WidgetType.SINGLE_KPI: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.singleKpi');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_single_kpi',
                isDisabled,
            };
        }
        case WidgetType.GAUGE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.gauge');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_gauge',
                isDisabled,
            };
        }
        case WidgetType.PERCENTAGE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.percentage');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_percentage',
                isDisabled,
            };
        }
        case WidgetType.LINE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.line');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_line',
                isDisabled,
            };
        }
        case WidgetType.BAR: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.bar');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_bar',
                isDisabled,
            };
        }
        case WidgetType.STACKED_BAR: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.stacked');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_stacked',
                isDisabled,
            };
        }
        case WidgetType.PIE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.pie');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_pie',
                isDisabled,
            };
        }
        case WidgetType.HEATMAP: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.heatMap');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_heatmap',
                isDisabled,
            };
        }
        case WidgetType.MULTI_DEVICE_HEATMAP: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.multiDeviceHeatMap');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_heatmap',
                isDisabled,
            };
        }
        case WidgetType.TEXT: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.text');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_richtext',
                isDisabled,
            };
        }
        case WidgetType.IMAGE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.image');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_image',
                isDisabled,
            };
        }
        case WidgetType.TABLE: {
            const tooltipMessage = i18n.t('widgets.widgetMenu.table');
            return {
                value: widgetType,
                id: widgetType,
                tooltip: pickCorrectTooltipMessage(isDisabled, tooltipMessage, isFeaturePresetSelected),
                icon: 'widget_table',
                isDisabled,
            };
        }
        default: {
            throw new Error('Unrecognised widget type');
        }
    }
};

const pickCorrectTooltipMessage = (isDisabled: boolean, tooltipMessage: string, isFeaturePresetSelected?: boolean) => {
    if (!isFeaturePresetSelected && isDisabled) {
        return i18n.t('widgets.widgetMenu.noPresetSelected');
    }
    if (isDisabled) {
        return i18n.t('widgets.widgetMenu.widgetTypeDisabled');
    }
    return tooltipMessage;
};

const checkIfDisabledApplies = (widgetType: WidgetType, enabledWidgets?: string[]) =>
    enabledWidgets ? !enabledWidgets.includes(widgetType) : false;
